<template>
  <div class="profitCalculation">
    <h2>利润测算</h2>
    <el-form :inline="true">
      <el-form-item label="测算区间">
        <el-date-picker v-model="searchParam.dates" type="daterange" start-placeholder="起" end-placeholder="止" style="width: 220px;" />
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()">搜索</el-button>
          <el-button @click="resetSearchParam()">重置</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="add()">新建</el-button>
          <el-button type="warning" :disabled="!(show.selected.length == 1)" @click="update()">详情</el-button>
          <el-button type="danger" :disabled="!(show.selected.length >= 1)" @click="del()">删除</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.list" @selection-change="selectionChange()" ref="tabRef" border style="height: calc(100vh - 310px);">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column width="100" align="center">
        <template #default="scope">
          <el-link type="primary" @click="update(scope.row)">{{ scope.row.id }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="operateDatetime" label="操作时间" width="180" show-overflow-tooltip>
        <template #default="scope">
          {{ util.parseTime(scope.row.operateDatetime) }}
        </template>
      </el-table-column>
      <el-table-column prop="beginDate" label="测算区间（起）" show-overflow-tooltip />
      <el-table-column prop="endDate" label="测算区间（止）" show-overflow-tooltip />
    </el-table>
    <div style="height: 10px;" />
    <el-pagination v-model:current-page="searchParam.pageNum" v-model:page-size="searchParam.pageSize" :page-sizes="[300, 500, 1000, 2000]" background layout="total, sizes, prev, pager, next, jumper" :total="data.total" @change="commitFindList()" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import apiNative from '../../apis/apiNative'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const tabRef = ref()

const data = reactive({
  total: 0,
  list: [],
  accumulate: {},
})

const show = reactive({
  selected: [],
})

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.pageNum = 1
  searchParam.pageSize = 300
  searchParam.dates = []
}
resetSearchParam()
const beforeSearchParam = cache.getObject(cache.keys.pageParam + 'profitCalculation')
if (beforeSearchParam) {
  Object.assign(searchParam, beforeSearchParam)
  cache.setObject(cache.keys.pageParam + 'profitCalculation', null)
}

const getPageParam = () => {
  const params = {}
  params.pageNum = searchParam.pageNum
  params.pageSize = searchParam.pageSize
  if (searchParam.dates && searchParam.dates.length == 2) {
    params.beginDateGe = util.parseTime(searchParam.dates[0], '{y}-{m}-{d}')
    params.endDateLe = util.parseTime(searchParam.dates[1], '{y}-{m}-{d}')
  }
  return params
}

const commitFindList = () => {
  api.get('/backend/profitCalculation/page', { params: getPageParam() }).then(res => {
    data.list = res.list
    data.total = res.total
  })
}
commitFindList()

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}

const add = () => {
  cache.setObject(cache.keys.pageParam + 'profitCalculation', searchParam)
  cache.setObject(cache.keys.pageParam + 'profitCalculationDetail', null)
  router.push('/profitCalculationDetail')
}

const update = (row) => {
  cache.setObject(cache.keys.pageParam + 'profitCalculation', searchParam)
  const profitCalculation = row ? row : tabRef.value.getSelectionRows()[0]
  cache.setObject(cache.keys.pageParam + 'profitCalculationDetail', profitCalculation)
  router.push('/profitCalculationDetail')
}

const del = () => {
  const ids = tabRef.value.getSelectionRows().map(profitCalculation => profitCalculation.id)
  ElMessageBox.confirm('', {
    title: '确认删除',
    message: '将要删除选中的 ' + ids.length + ' 项。',
    autofocus: false,
    confirmButtonText: '确认',
    cancelButtonText: '取消'
  }).then(() => {
    api.post('/backend/profitCalculation/del', { ids: ids }).then(() => {
      ElMessage.success('删除成功')
      commitFindList()
    })
  })
}

</script>

<style lang="less"></style>